import { Link } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import { PageHeader } from "@/components/page-header";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { useList } from "@/hooks/use-list";
import { api } from "@/lib/api";
import { Plus, Trash2 } from "lucide-react";

export default function ProjectsPage() {
  const { data, isLoading } = useList<any>("/projects");
  const qc = useQueryClient();

  async function del(id: string, name: string) {
    if (!confirm(`Delete project "${name}"?`)) return;
    await api.delete(`/projects/${id}`);
    qc.invalidateQueries({ queryKey: ["/projects"] });
  }

  return (
    <>
      <PageHeader
        title="Delivery"
        description="Active projects, milestones, CSAT/NPS."
        actions={<Button asChild><Link to="/projects/new"><Plus className="mr-1 h-4 w-4"/>New Project</Link></Button>}
      />
      <div className="grid gap-4 p-6 md:grid-cols-2 lg:grid-cols-3">
        {isLoading && <p className="text-sm text-muted-foreground">Loading…</p>}
        {!isLoading && (data?.data?.length ?? 0) === 0 && (
          <p className="text-sm text-muted-foreground">
            No projects yet. Projects are auto-created when a consulting/staffing/government deal is marked CLOSED_WON.
          </p>
        )}
        {data?.data?.map((p: any) => (
          <Card key={p.id}>
            <CardHeader className="flex-row items-start justify-between pb-2">
              <div>
                <CardTitle className="text-base"><Link to={`/projects/${p.id}`} className="hover:underline">{p.name}</Link></CardTitle>
                <div className="mt-1"><Badge variant="secondary">{p.status}</Badge></div>
              </div>
              <Button variant="ghost" size="icon" onClick={() => del(p.id, p.name)} aria-label="Delete">
                <Trash2 className="h-4 w-4" />
              </Button>
            </CardHeader>
            <CardContent className="text-sm">
              <div>PM: {p.pm?.name ?? "Unassigned"}</div>
              <div>Kickoff: {p.kickoffDate ? new Date(p.kickoffDate).toLocaleDateString() : "—"}</div>
              <div>Milestones: {p.milestones?.length ?? 0}</div>
              <div>CSAT: {p.csatScore ?? "—"} / 10</div>
            </CardContent>
          </Card>
        ))}
      </div>
    </>
  );
}
